<template>
  <div class="text-center">
    <p>Ordenar por</p>
    <div class="form-inline form-group d-flex justify-content-center">
      <select
        class="form-control mx-1"
        @change="handleChangeSelect"
        v-model="sort"
      >
        <option value="name">Nombre</option>
        <option value="price">Precio</option>
        <option value="creationDate">Fecha</option>
        <option value="seller">Vendedor</option>
      </select>
      <select
        class="form-control mx-1 mt-4 mt-sm-0"
        v-model="asc"
        @change="handleChangeSelect"
      >
        <option :value="true">Ascendente</option>
        <option :value="false">Descendente</option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderBy",
  data() {
    return {
      sort: "creationDate",
      asc: false,
    };
  },
  created: function () {},
  methods: {
    handleChangeSelect() {
      this.$parent.handleOrderBy(this.sort, this.asc);
    },
  },
};
</script>

<style>
</style>